import * as React from 'react';
import Scrollbars from 'react-custom-scrollbars';

import { BaseComponent } from '../BaseComponent';
import { PopupFlagPosition } from '../../constants/PopupFlagPositions';
import { SelectBoxOption } from '../../stores/SelectBoxStore';
import { BasePopupMenuTitleSetting, BasePopupMenuHeader } from './BasePopupMenuHeader';
import { BasePopupMenuOption } from './BasePopupMenuOption';

export interface BasePopupMenuContentProps {
    flagPosition: PopupFlagPosition;
    defaultValue: any;
    open: boolean;
    options: Array<SelectBoxOption>;
    title?: BasePopupMenuTitleSetting;
    changeCallback?: (pValue: any) => void; // if not set, options must have own callback functions
    transform?: boolean;
    alignBottom?: boolean;
}

export interface BasePopupMenuContentState {
}

export class BasePopupMenuContent extends BaseComponent<BasePopupMenuContentProps, BasePopupMenuContentState> {
    protected scrollArea: JQuery;

    public componentDidMount(): void {
        this.addCustomScroll();
    }

    public componentDidUpdate(): void {
        this.addCustomScroll();
    }

    public render(): JSX.Element | null {
        if (this.props.open) {
            let tOptionsClass: string = 'egr-select-options';
            const divProps: React.HTMLProps<HTMLDivElement> = {style: {}};
            if (!this.props.alignBottom) {
                switch (this.props.flagPosition) {
                    case PopupFlagPosition.TOPLEFT:
                        tOptionsClass += ' with-popupflag top-arrow align-left';
                        break;
                    case PopupFlagPosition.TOPRIGHT:
                        tOptionsClass += ' with-popupflag top-arrow align-right';
                        if (this.props.transform) { divProps.style = {transform: 'translateX(-100%) translateX(36px)'}; }
                        break;
                    case PopupFlagPosition.LEFT:
                        tOptionsClass += ' with-popupflag left-arrow';
                        break;
                    case PopupFlagPosition.BOTTOMLEFT:
                        tOptionsClass += ' with-popupflag bottom-arrow align-left';
                        if (this.props.transform) { divProps.style = {transform: 'translateY(-100%) translateY(-16px)'}; }
                        break;
                    case PopupFlagPosition.BOTTOMRIGHT:
                        tOptionsClass += ' with-popupflag bottom-arrow align-right';
                        if (this.props.transform) { divProps.style = {transform: 'translateX(-100%) translateX(36px) translateY(-100%) translateY(-16px)'}; }
                        break;
                    default:
                        break;
                }
            } else if (this.props.transform) {
                divProps.style = {
                    left: '50%',
                    top: '50%',
                    transform: 'translate(-50%, -50%)',
                    maxHeight: 295
                };
            }
            divProps.className = tOptionsClass;
            return (
                <div {...divProps}>
                    {this.props.title != null ? <BasePopupMenuHeader {...this.props.title}/> : null}
                    <Scrollbars autoHeight={true}>
                        {this.props.options.map(this.getOption)}
                    </Scrollbars>
                </div>
            );
        }

        return null;
    }

    protected getOption = (pOption: SelectBoxOption, index: number): JSX.Element | null => {
        if (pOption.hidden) {
            return null;
        }
        return (
            <BasePopupMenuOption
                key={index}
                {...pOption}
                first={index === 0}
                active={(
                    this.props.defaultValue === pOption.value ||
                    (
                        (this.props.defaultValue != null && this.props.defaultValue != null) &&
                        (this.props.defaultValue.toString() === pOption.value.toString())
                    )
                )}
                optionClick={this.optionClick}
            />
        );
    };

    protected addCustomScroll(): void {
        if (this.scrollArea != null && this.props.transform) {
            this.scrollArea.scrollbar({
                ignoreOverlay: true,
                ignoreMobile: true
            });
        }
    }

    protected setScrollArea = (node: HTMLDivElement): void => {
        this.scrollArea = jQuery(node);
    };

    protected optionClick = (pValue: string | number): void => {
        if (this.props.changeCallback && pValue != null) {
            this.props.changeCallback(pValue);
        }
    };
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/popupmenu/BasePopupMenuContent.tsx